import { GET_ROOM_TYPE_REQUEST ,GET_ROOM_TYPE_SUCCESS,GET_ROOM_TYPE_FAILURE,
POST_ROOM_TYPE_REQUEST ,POST_ROOM_TYPE_SUCCESS,POST_ROOM_TYPE_FAILURE,
DELETE_ROOM_TYPE_REQUEST,
DELETE_ROOM_TYPE_SUCCESS,
DELETE_ROOM_TYPE_FAILURE,
PATCH_ROOM_TYPE_REQUEST,
PATCH_ROOM_TYPE_SUCCESS,
PATCH_ROOM_TYPE_FAILURE,
GET_ROOM_TYPE_NAME_REQUEST,
GET_ROOM_TYPE_NAME_SUCCESS,
GET_ROOM_TYPE_NAME_FAILURE,
GET_ROOM_STATUS_REQUEST,
GET_ROOM_STATUS_SUCCESS,
GET_ROOM_STATUS_FAILURE,
GET_ALL_ROOM_NUMBER_WITH_ID_SUCCESS,
GET_ALL_ROOM_NUMBER_WITH_ID_REQUEST,
GET_ALL_ROOM_NUMBER_WITH_ID_FAILURE,
GET_ALL_ROOM_TYPE_WITH_ID_REQUEST,
GET_ALL_ROOM_TYPE_WITH_ID_SUCCESS,
GET_ALL_ROOM_TYPE_WITH_ID_FAILURE,  
GET_ROOM_LIST_REQUEST, 
GET_ROOM_LIST_SUCCESS, 
GET_ROOM_LIST_FAILURE} from "../../../Utils/Constant";

  export const roomTypeRequest = (payload) => {
    return {
      type: GET_ROOM_TYPE_REQUEST,
      payload: payload,
    };
  };
  
  export const roomTypeSuccess = (data) => {
    return {
      type: GET_ROOM_TYPE_SUCCESS,
      payload: data,
    };
  };
  
  export const roomTypeFailure = (error) => {
    return {
      type: GET_ROOM_TYPE_FAILURE,
      payload: error,
    };
  };
    
  //room type name
  export const roomTypeNameRequest = (payload) => {
    return {
      type: GET_ROOM_TYPE_NAME_REQUEST,
      payload: payload,
    };
  };
  
  export const roomTypeNameSuccess = (data) => {
    return {
      type: GET_ROOM_TYPE_NAME_SUCCESS,
      payload: data,
    };
  };
  
  export const roomTypeNameFailure = (error) => {
    return {
      type: GET_ROOM_TYPE_NAME_FAILURE,
      payload: error,
    };
  };
    //room  status
    export const roomStatusRequest = (payload) => {
      return {
        type: GET_ROOM_STATUS_REQUEST,
        payload: payload,
      };
    };
    
    export const roomStatusSuccess = (data) => {
      return {
        type: GET_ROOM_STATUS_SUCCESS,
        payload: data,
      };
    };
    
    export const roomStatusFailure = (error) => {
      return {
        type: GET_ROOM_STATUS_FAILURE,
        payload: error,
      };
    };
  
  //add room
   export const addRoomTypeRequest = (payload) => {
      return {
        type: POST_ROOM_TYPE_REQUEST,
        payload: payload,
      };
    };
    
    export const addRoomTypeSuccess = (data) => {
      return {
        type: POST_ROOM_TYPE_SUCCESS,
        payload: data,
      };
    };
    
    export const addRoomTypeFailure = (error) => {
      return {
        type: POST_ROOM_TYPE_FAILURE,
        payload: error,
      };
    };

    //deleteroom
    export const deleteRoomTypeRequest = (payload) => {
      return {
        type: DELETE_ROOM_TYPE_REQUEST,
        payload: payload,
      };
    };
    
    export const deleteRoomTypeSuccess = (data) => {
      return {
        type: DELETE_ROOM_TYPE_SUCCESS,
        payload: data,
      };
    };
    
    export const deleteRoomTypeFailure = (error) => {
      return {
        type: DELETE_ROOM_TYPE_FAILURE,
        payload: error,
      };
    };

    export const patchRoomTypeRequest = (payload) => {
      return {
        type: PATCH_ROOM_TYPE_REQUEST,
        payload,
      };
    };
    
    export const patchRoomTypeSuccess = (data) => {
      return {
        type: PATCH_ROOM_TYPE_SUCCESS,
        payload: data,
      };
    };
    
    export const patchRoomTypeFailure = (error) => {
      return {
        type: PATCH_ROOM_TYPE_FAILURE,
        payload: error,
      };
    };
    
    // Get All Room Number With ID
    export const getAllRoomNumberWithIDRequest = (payload) => {
      return {
        type: GET_ALL_ROOM_NUMBER_WITH_ID_REQUEST,
        payload,
      };
    };
    
    export const getAllRoomNumberWithIDSuccess = (data) => {
      return {
        type: GET_ALL_ROOM_NUMBER_WITH_ID_SUCCESS,
        payload: data,
      };
    };
    
    export const getAllRoomNumberWithIDFailure = (error) => {
      return {
        type: GET_ALL_ROOM_NUMBER_WITH_ID_FAILURE,
        payload: error,
      };
    };
    
    // Get All Room Type With ID
    export const getAllRoomTypeWithIDRequest = (payload) => {
      return {
        type: GET_ALL_ROOM_TYPE_WITH_ID_REQUEST,
        payload,
      };
    };
    
    export const getAllRoomTypeWithIDSuccess = (data) => {
      return {
        type: GET_ALL_ROOM_TYPE_WITH_ID_SUCCESS,
        payload: data,
      };
    };
    
    export const getAllRoomTypeWithIDFailure = (error) => {
      return {
        type: GET_ALL_ROOM_TYPE_WITH_ID_FAILURE,
        payload: error,
      };
    };

    export const getRoomListRequest = (payload) => {
      return {
        type: GET_ROOM_LIST_REQUEST,
        payload,
      };
    };
    
    export const getRoomListSuccess = (data) => {
      return {
        type: GET_ROOM_LIST_SUCCESS,
        payload: data,
      };
    };
    
    export const getRoomListFailure = (error) => {
      return {
        type: GET_ROOM_LIST_FAILURE,
        payload: error,
      };
    };